<template lang="">
  <div>
    <div class="left_tit flex align-center flex-center">栏目导航</div>
    <div class="news_l padding-bottom leftss">
      <ul class="big_ul">
        <li class="cursor" v-for="(item, index) in leftlists" :key="item.id">
          <div
            v-if="no_link"
            class=""
            @click="rightlist2(item.id, index)"
            :class="[currentIndex == index ? 'left_fathersel' : 'left_father']"
          >
            <p class="text-center flex align-center text-weight">
              {{ item.name }}
            </p>
          </div>
          <router-link
            v-else
            :to="item.link ? item.link : ''"
            class=""
            
            active-class="text-blues"
          >
            <p
              class="text-center flex align-center text-weight"
              style="line-height: 35px;padding-left: 17px;"
              @click="rightlist2(item.id, index)"
            >
              {{ item.name }}
            </p>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "LeftNav",
  props: {
  no_link: {
    type: Boolean,
    default: true
  },
  leftlists: {
    type: Array,
    default: () => [] // 使用工厂函数返回默认数组
  },
  currentIndex: {
      type: Number,
      default: 0
    }
  },
  // props: ["leftlists", "currentIndex"],
  methods: {
    rightlist2(id, index) {
      console.log('Event triggered!', id, index); // 添加调试日志
      this.$emit("rightlist2", {
        passId: id,
        index: index,
      });
    },
    
  },
};
</script>

<style src="../../../vab/styles/gaikuang/gaikuang_big.css" scoped></style>
<style src="../../../vab/styles/gaikuang/gaikuang_mid.css" scoped></style>
<style src="../../../vab/styles/gaikuang/gaikuang_small.css" scoped></style>
